<div id="mainDiv" class="reset-page-wrapper">
    <!-- Ambient Lighting Backdrop Elements -->
    <div class="ambient-glow glow-top"></div>
    <div class="ambient-glow glow-bottom"></div>

    <!-- Reset Card Container -->
    <div class="reset-card-container">
        <div class="card reset-card shadow-lg">
            <div class="card-body p-4 p-sm-5">
                <!-- Brand Header -->
                <div class="brand-header text-center mb-4">
                    <div class="logo-wrapper mb-3">
                        <img class="logo-img img-fluid" src="assets/aetherpsl-logo.png" alt="Aether HRMS">
                    </div>
                    <div class="security-badge-pill mb-2">
                        <i class="fa-solid fa-key text-primary me-1"></i>
                        <span>Credential Security</span>
                    </div>
                    <h2 class="reset-title">Reset Your Password</h2>
                    <p class="reset-subtitle">
                        Hello <strong class="text-dark">{{ userName }}</strong>, please enter and confirm your new secure password.
                    </p>
                </div>

                <!-- Form -->
                <form [formGroup]="resetPassForm" (ngSubmit)="onConfirm()" class="reset-form">
                    <!-- New Password Field -->
                    <div class="form-group mb-3 text-start">
                        <label class="form-label input-label" for="newPassword">
                            New Password <span class="text-danger">*</span>
                        </label>
                        <div class="input-icon-group">
                            <span class="input-icon-addon">
                                <i class="fa-solid fa-lock"></i>
                            </span>
                            <input [type]="show ? 'text' : 'password'" autocomplete="new-password"
                                placeholder="Enter at least 6 characters" formControlName="newPassword" id="newPassword"
                                maxlength="100" required class="form-control modern-input input-with-toggle" />
                            <button class="btn btn-password-toggle" type="button" (click)="showPassword()"
                                title="Toggle password visibility">
                                <i [class]="passwordState"></i>
                            </button>
                        </div>
                        @if (confirmed && f.newPassword.errors?.['required']) {
                        <div class="error-feedback text-danger small mt-1">
                            <i class="fa-solid fa-circle-exclamation me-1"></i>New password is required.
                        </div>
                        }
                        @if (f.newPassword.errors?.['minlength']) {
                        <div class="error-feedback text-danger small mt-1">
                            <i class="fa-solid fa-circle-exclamation me-1"></i>Password must be at least 6 characters.
                        </div>
                        }
                    </div>

                    <!-- Confirm Password Field -->
                    <div class="form-group mb-4 text-start">
                        <label class="form-label input-label" for="confirmPassword">
                            Confirm Password <span class="text-danger">*</span>
                        </label>
                        <div class="input-icon-group">
                            <span class="input-icon-addon">
                                <i class="fa-solid fa-shield-halved"></i>
                            </span>
                            <input [type]="showConfirm ? 'text' : 'password'" autocomplete="new-password"
                                placeholder="Re-enter your new password" formControlName="confirmPassword" id="confirmPassword"
                                maxlength="100" required class="form-control modern-input input-with-toggle" />
                            <button class="btn btn-password-toggle" type="button" (click)="showConfirmPassword()"
                                title="Toggle confirm password visibility">
                                <i [class]="passwordStateConfirm"></i>
                            </button>
                        </div>

                        <!-- Validation Feedback -->
                        @if (confirmed && f.confirmPassword.errors?.['required']) {
                        <div class="error-feedback text-danger small mt-1">
                            <i class="fa-solid fa-circle-exclamation me-1"></i>Confirm password is required.
                        </div>
                        }
                        @if (confirmed && f.confirmPassword.value && f.newPassword.value !== f.confirmPassword.value) {
                        <div class="error-feedback text-danger small mt-1">
                            <i class="fa-solid fa-circle-xmark me-1"></i>Passwords do not match.
                        </div>
                        }
                        @if (f.confirmPassword.value && f.newPassword.value === f.confirmPassword.value) {
                        <div class="success-feedback text-success small mt-1">
                            <i class="fa-solid fa-circle-check me-1"></i>Passwords match.
                        </div>
                        }
                    </div>

                    <!-- Submit & Cancel Actions -->
                    <div class="form-actions d-flex flex-column gap-2 mb-3">
                        <button type="submit" class="btn btn-primary btn-confirm-submit w-100">
                            <i class="fa-solid fa-circle-check me-2"></i>
                            <span>Update Password</span>
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-cancel w-100" (click)="onCancel()">
                            <i class="fa-solid fa-arrow-left me-1"></i>
                            <span>Back to Sign In</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- System Version / Copyright Footer -->
        <div class="reset-page-footer text-center mt-3">
            <p class="text-muted small mb-0">
                &copy; {{ currentYear }} Aether Enterprise Application LLP. All rights reserved.
            </p>
        </div>
    </div>
</div>